import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  settingsService,
  type BankAccount,
  type CreateBankAccountInput,
  type UpdateBankAccountInput,
} from '@/services/settings.service';
import { settingsKeys } from '@/services/queryKeys';

export function useBankAccounts() {
  return useQuery<BankAccount[]>({
    queryKey: settingsKeys.bankAccounts(),
    queryFn: () => settingsService.listBankAccounts(),
    retry: 0,
  });
}

export function useCreateBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateBankAccountInput) => settingsService.createBankAccount(body),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.bankAccounts() }),
  });
}

export function useUpdateBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: string;
      body: UpdateBankAccountInput;
    }) => settingsService.updateBankAccount(id, body),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.bankAccounts() }),
  });
}

export function useDeleteBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => settingsService.deleteBankAccount(id),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.bankAccounts() }),
  });
}

export function useSetDefaultBankAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => settingsService.setDefaultBankAccount(id),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: settingsKeys.bankAccounts() }),
  });
}
